import styled from 'styled-components';

export const FilterCheckboxWrapper = styled.div`
  margin-bottom: 0.5em;
  &:last-child {
    margin-bottom: 0;
  }

  .checkbox-label {
    margin-left: 0.8em;
  }
`;

export const FilterComponentStyle = styled.div`
  &.padding-left {
    padding: 1em 0 1em 1em;
  }
`;
